import React from "react";
import { DataGrid } from '@mui/x-data-grid';
import { Link } from "react-router-dom";
import {tagResources} from "../endpoints";
import useToken from "../useToken";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import SearchIcon from "@material-ui/icons/Search";
import Box from "@material-ui/core/Box";
import { esES } from '@mui/x-data-grid';
import IconButton from '@mui/material/IconButton'
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'

class TablaAvanceVirtualizada extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            cliente: null,
            estado_inv: null,
            titulo_columna: "Importe",
            factor: false,
            sin_factor: false,
            cargando: true,
            searchText: '',
            expandedRows: {},
            loadingRows: {},
            cacheHijos: {}
        };
    }

    applySearchFilter = () => {
        const { searchText } = this.state;
        if (!searchText) return this.props.datos;
        return this.props.datos.filter((row) =>
            Object.values(row).some(
                (value) =>
                    value &&
                    value.toString().toLowerCase().includes(searchText.toLowerCase())
            )
        );
    };

    componentDidMount() {
        this.obtenerTipoCampos();
        const datos_inv = useToken.getDatos();
        this.setState({
            cliente: datos_inv.app,
            estado_inv: datos_inv.estado,
            titulo_columna: datos_inv.app === 'sodimac' ? "Costo" : "Importe",
            cargando: false
        },);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.datos !== this.props.datos) {
            this.obtenerTipoCampos();
            const datos_inv = useToken.getDatos();
            this.setState({
                cliente: datos_inv.app,
                estado_inv: datos_inv.estado,
                titulo_columna: datos_inv.app === 'sodimac' ? "Costo" : "Importe",
                cargando: false
            },);
        }
    }

    getColumnVisibilityModel = () => {
        const { cliente } = this.state;
        return {
            registros_revisados: cliente === 'sodimac',
            porcentaje_revisados: true,
            tag_revisados: cliente === 'sodimac',
            tag_revisados_porcentaje: cliente === 'sodimac',
            importe: cliente === 'sodimac',
            importe_revisado: cliente === 'sodimac',
            importe_revisado_porcentaje: cliente === 'sodimac',
        };
    };

    obtenerTipoCampos = () => {
        tagResources.obtenerTipoCampos().then(async response => {
            if (response.ok) return await response.json();
            throw new Error('Error al obtener tipo de campos');
        }).then(result => {
            this.setState({
                factor: result === "con_factor",
                sin_factor: result !== "con_factor"
            });
        }).catch(console.error);
    };

    verifica = (row, dato, tipo) => {
        if (dato !== null && dato > 0) {
            const to = `/tags_avance/${tipo}/${row.id}/${row.descripcion}`;
            return (
                <Link
                    style={{ color: '#000000' }}
                    target={this.state.cliente === 'sodimac' || this.state.cliente === 'sodimac_auditoria' ? "_self" : "_blank"}
                    rel="noreferrer"
                    to={to}
                >
                    {new Intl.NumberFormat("de-DE").format(dato)}
                </Link>
            );
        }
        return 0;
    };

    verificaNulo = (valor) => valor === null ? 0 : valor;

    buildColumns = () => {
        const { titulo_columna } = this.state;

        return [
            {
                field: "expand",
                headerName: "",
                flex: 1,
                minWidth: 32,
                maxWidth: 50,
                align: "left",        // 👈 importante
                headerAlign: "left",
                renderCell: (params) => {
                    const row = params.row
                    const id = row.id

                    const isExpanded = this.state.expandedRows[id]
                    const isLoading = this.state.loadingRows[id]

                    // 🔥 SOLO mostrar si es raíz
                    const esRaiz = row.padre === -1

                    if (!esRaiz) return null

                    return (
                        <IconButton
                            size="small"
                            sx={{
                                padding: "0px"
                            }}
                            onClick={() => this.handleToggle(row)}
                        >
                            {isExpanded ? (
                                <KeyboardArrowDownIcon fontSize="small" />
                            ) : (
                                <KeyboardArrowRightIcon fontSize="small" />
                            )}
                        </IconButton>
                    )
                }
            },
            {
                field: 'ubicacion_path',
                headerName: 'Ubicación',
                flex: 2,
                minWidth: 255,
                render: (row) => (
                    <div style={{ paddingLeft: (row.nivel || 0) * 20 }}>
                        {row.descripcion}
                    </div>
                ),
                renderCell: (params) => (
                    <div
                        style={{
                            whiteSpace: 'normal',
                            wordBreak: 'break-word',
                            overflow: 'visible',
                            lineHeight: 1.4,
                            paddingTop: 4,
                            paddingBottom: 4,
                        }}
                    >
                        {params.value}
                    </div>
                ),
                align: 'left',
                headerAlign: 'left'},
            {
                field: 'tag_total', headerName: 'Tot.Pat.', type: 'number',flex: 1, minWidth: 100,
                valueFormatter: ({ value }) => new Intl.NumberFormat("de-DE").format(value),
                align: 'left',
                headerAlign: 'left'
            },
            {
                field: 'tag_contado', headerName: 'Inven.', type: 'number', flex: 1, minWidth: 90,
                renderCell: (params) => this.verifica(params.row, params.row.tag_contado, "contados"),
                align: 'left',
                headerAlign: 'left'
            },
            {
                field: 'tag_nulo', headerName: 'Nulos', type: 'number',  flex: 1, minWidth: 84,
                renderCell: (params) => this.verifica(params.row, params.row.tag_nulo, "nulos"),
                align: 'left',
                headerAlign: 'left'
            },
            {
                field: 'tag_pendiente', headerName: 'Pendientes', type: 'number', flex: 1, minWidth: 110,
                renderCell: (params) => this.verifica(params.row, params.row.tag_pendiente, "pendientes"),
                align: 'left',
                headerAlign: 'left'
            },
            {
                field: 'cantidad', headerName: 'Cant. capt', type: 'number',  flex: 1, minWidth: 120,
                valueFormatter: ({ value }) => new Intl.NumberFormat("de-DE").format(value),
                align: 'left',
                headerAlign: 'left'
            },
            { field: 'registros', headerName: 'Registros', type: 'number',  flex: 1, minWidth: 109,align: 'left',
                headerAlign: 'left'
            },
            {
                field: 'registros_revisados', headerName: 'Reg.Rev.', type: 'number', flex: 1, minWidth: 109,
                valueGetter: (params) => this.verificaNulo(params.row.registros_revisados),
                align: 'left',
                headerAlign: 'left'
            },
            {
                field: 'porcentaje_revisados', headerName: 'Reg.Rev.(%)', type: 'number',  flex: 1, minWidth: 130,
                valueGetter: (params) => (((params.row.porcentaje_revisados || 0) * 100)/100).toFixed(2),
                align: 'left',
                headerAlign: 'left'
            },
            {
                field: 'tag_revisados', headerName: 'Tags Rev.', type: 'number', align: 'left', flex: 1, minWidth: 111,
                headerAlign: 'left'
            },
            {
                field: 'tag_revisados_porcentaje', headerName: 'Tags Rev.(%)', type: 'number',  flex: 1, minWidth: 133,
                valueGetter: (params) => {
                    const contado = params.row.tag_contado || 0;
                    return contado > 0 ? ((params.row.tag_revisados / contado) * 100).toFixed(2) : '0.00';
                },
                align: 'left',
                headerAlign: 'left'
            },
            {
                field: 'importe', headerName: titulo_columna, type: 'number', flex: 1, minWidth: 120,
                valueGetter: (params) => params.row.importe || 0,
                valueFormatter: ({ value }) => new Intl.NumberFormat("de-DE").format(value),
                align: 'left',
                headerAlign: 'left'
            },
            {
                field: 'importe_revisado', headerName: `${titulo_columna} Rev.`, type: 'number', flex: 1, minWidth: 125,
                valueGetter: (params) => params.row.importe_revisado || 0,
                valueFormatter: ({ value }) => new Intl.NumberFormat("de-DE").format(value),
                align: 'left',
                headerAlign: 'left'
            },
            {
                field: 'importe_revisado_porcentaje', headerName: `${titulo_columna} Rev.(%)`, type: 'number',  flex: 1, minWidth: 140,
                valueGetter: (params) => {
                    const importe = params.row.importe || 0;
                    return importe > 0 ? ((params.row.importe_revisado / importe) * 100).toFixed(2) : '0.00';
                },
                align: 'left',
                headerAlign: 'left'
            },
            {
                field: 'avance', headerName: 'Avance(%)', type: 'number',  flex: 1, minWidth: 119,
                valueGetter: (params) => ((params.row.avance || 0) * 100).toFixed(2),
                align: 'left',
                headerAlign: 'left'
            },
          
        ];
    }

    getRowClassName = (params) => {
        const row = params.row;
        if (row.descripcion === 'SIN UBICACION') return 'fila-sinubicacion';
        if (row.avance === 1 && row.descripcion !== 'SIN UBICACION') return 'fila-verde';
        if (row.cant_inv === 0) return 'fila-roja';
        return '';
    }

    handleToggle = async (row) => {
        const { expandedRows, cacheHijos } = this.state

        // COLLAPSE
        if (expandedRows[row.id]) {
            const nuevosDatos = this.removeChildren(row.id, this.props.datos)

            this.setState({
                expandedRows: {
                    ...expandedRows,
                    [row.id]: false
                }
            })

            this.props.setDatos(nuevosDatos) // 👈 importante
            return
        }

        // EXPAND

        if (cacheHijos[row.id]) {
            this.insertChildren(row, cacheHijos[row.id])
            return
        }

        this.setState({
            loadingRows: {
                ...this.state.loadingRows,
                [row.id]: true
            }
        })

        const res = await this.props.getHijos(row.id)
        const data = await res.json()

        this.setState({
            cacheHijos: {
                ...this.state.cacheHijos,
                [row.id]: data.avance
            }
        })

        this.insertChildren(row, data.avance)

        this.setState({
            loadingRows: {
                ...this.state.loadingRows,
                [row.id]: false
            }
        })
    }

    insertChildren = (row, hijos) => {
        const nuevosDatos = []

        this.props.datos.forEach(r => {
            nuevosDatos.push(r)

            if (r.id === row.id) {
                hijos.forEach(h => {
                    nuevosDatos.push({
                        ...h,
                        nivel: (row.nivel || 0) + 1,
                        parentId: row.id
                    })
                })
            }
        })

        this.setState({
            expandedRows: {
                ...this.state.expandedRows,
                [row.id]: true
            }
        })

        this.props.setDatos(nuevosDatos)
    }

    removeChildren = (parentId, datos) => {
        let idsAEliminar = []

        const getAllChildren = (id) => {
            const hijos = datos.filter(r => r.parentId === id)

            hijos.forEach(h => {
                idsAEliminar.push(h.id)
                getAllChildren(h.id) // recursivo
            })
        }

        getAllChildren(parentId)

        return datos.filter(r => !idsAEliminar.includes(r.id))
    }

    render() {
        return (
            <div style={{height: 600, width: '100%' }}>
                <Box display="flex" alignItems="center" justifyContent="space-between" marginBottom={1}>
                    <TextField
                        label="Buscar..."
                        variant="outlined"
                        size="small"
                        placeholder="Escribe para buscar"
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <SearchIcon/>
                                </InputAdornment>
                            ),
                        }}
                        value={this.state.searchText}
                        onChange={(e) => this.setState({searchText: e.target.value})}
                        style={{width: 300}}
                    />
                </Box>
                    <DataGrid
                        sx={{
                            '& .MuiDataGrid-columnHeaderTitleContainer': {
                                flexDirection: 'row', // Fuerza que el texto vaya antes, y la flecha después
                            },
                            '& .fila-verde': {
                                backgroundColor: '#6fbf73',
                            },
                            '& .fila-roja': {
                                backgroundColor: '#FD8080',
                            },
                            '& .fila-sinubicacion': {
                                backgroundColor: '#EC7063',
                            },
                            '& .MuiDataGrid-cell': {
                                fontSize: '15px',           // 🔠 Tamaño de texto
                                justifyContent: 'flex-start', // ⬅️➡️ Justificación horizontal (flexbox)
                                alignItems: 'center',       // ⬆️⬇️ Alineación vertical
                                display: 'flex',            // Necesario para justificar el contenido
                            },
                            '& .MuiDataGrid-columnHeader': {
                                fontSize: '14px',
                                fontWeight: 'bold',
                                justifyContent: 'center',
                                display: 'flex',
                            },
                        }}
                        autoHeight={true}
                        disableColumnResize={true}
                        rows={this.applySearchFilter()}
                        columns={this.buildColumns()}
                        disableColumnMenu
                        loading={this.state.cargando}
                        columnVisibilityModel={this.getColumnVisibilityModel()}
                        getRowId={(row) => row.id}
                        getRowSpacing={() => ({top: 0, bottom: 0})}
                        density="standard"
                        localeText={esES.components.MuiDataGrid.defaultProps.localeText}
                        pageSizeOptions={[10, 25, 50, 100]}
                        getRowHeight={() => 'auto'}
                        initialState={{
                            pagination: {
                                paginationModel: {pageSize: 50, page: 0},
                            },
                        }}
                        getRowClassName={this.getRowClassName}
                    />
            </div>
        );
    }
}

export default TablaAvanceVirtualizada;
